const additemformText = {
  title: "Ürün Detayları",
  name: {
    label: "Ürün adı*",
    placeholder: "Örnek: Iphone 12 Pro Max",
  },
  details: {
    label: "Açıklama*",
    placeholder: "Ürün açıklaması girin",
  },
  category: {
    label: "Kategori*",
    placeholder: "Kategori Seç",
  },
  brand: {
    label: "Marka",
    placeholder: "Marka Seç",
  },
  color: {
    label: "Renk",
    placeholder: "Renk Seç",
  },
  usage: {
    label: "Kullanım Durumu*",
    placeholder: "Kullanım Durumu Seç",
  },
  price: {
    label: "Fiyat*",
    placeholder: "Bir Fiyat Girin",
  },
  option: {
    uncheckedText: "Teklif Opsiyonu",
    checkedText: "Fiyat ve Teklif Opsiyonu",
  },
  image: {
    text: "Ürün Görseli",
  },
  save: "Kaydet",
  upload: {
    upperText: "Sürükleyip bırakarak yükle",
    label: "Görsel Seçin",
    constraint: "PNG/JPEG/JPG Dosya boyutu max. 400kb",
  },
};

export default additemformText;
